import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const HelpMessage = ({
  text
}) => {
  const content = text?.__html ? {
    dangerouslySetInnerHTML: text
  } : {
    children: text
  };
  return /*#__PURE__*/_jsx("p", {
    className: "form-help",
    ...content
  });
};
export default HelpMessage;